import Vue from 'vue';
export default Vue.extend({
    name: 'orangeLoanHome',
    data: function () {
        return {
            status: 0,
            modelStatus: false,
            introduce: [
                {
                    img: require('../../../assets/images/orange-loan/percent-icon.svg'),
                    title: '日费率0.433‰',
                    des: '按日计息 随借随还',
                },
                {
                    img: require('../../../assets/images/orange-loan/proportion-icon.svg'),
                    title: '融资比例高',
                    des: '最高融资车价80%',
                },
                {
                    img: require('../../../assets/images/orange-loan/copywriting-icon.svg'),
                    title: '步骤很简单',
                    des: '3步即可完成',
                },
                {
                    img: require('../../../assets/images/orange-loan/speed-icon.svg'),
                    title: '放款极速',
                    des: '当日申请 T+2日内放款',
                },
            ],
        };
    },
    created: function () {
        if (this.$route.query.query) {
            this.modelStatus = true;
            this.status = 0;
        }
        else {
            this.getCreditMsg();
        }
    },
    methods: {
        getCreditMsg: function () {
            var _this = this;
            this.$request({
                method: 'post',
                url: '/proxy/oneCar/api/credit/query',
            }).then(function (res) {
                if (!res)
                    return;
                if (res && !res.errorCode) {
                    var data = res.data;
                    _this.status = data ? data.status : 0;
                    if (!data) {
                        _this.modelStatus = true;
                        return;
                    }
                    if (_this.status !== 1) {
                        _this.$router.push({
                            name: 'orangeLoanCreditStatus',
                            query: { status: _this.status },
                        });
                        return;
                    }
                    _this.$router.push({ name: 'orangeLoanBorrow' });
                }
            });
        },
        toCredit: function () {
            this.$router.push({
                name: 'orangeLoanCredit',
                query: { status: this.status },
            });
        },
    },
});
